<div class="row mx-0">
  <!-- validate referal code  -->
  <div *ngIf="!isReferalCodeVerified">
    <div class="col-12 px-0">
      <div class="pointer-cursor position-absolute right-align z-999 m-4">
        <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
      </div>
      <img src="assets/images/signup-image.png" alt="" class="w-100">
    </div>
    <div class="col-12 px-0 body-content">
      <div class="row mx-0">
        <div class="col-12 px-0 text-center signupheading">
          <p class="amatic-bold">{{'Learn sustainable goals to transform our world' | translate}}</p>
        </div>
        <div class="col-12 px-0 text-center">
          <p class="mulish-normal text-14 color-5F5F5F">
            {{'Welcome to Global expidition gaming platform.' | translate}}<br>
            {{'Please enter your referral code to continue' | translate}}</p>
        </div>
        <div class="col-12 px-0 text-left">
          <div>
            <form [formGroup]="referalForm" (keyup.enter)="validateReferalCode()">
              <!-- <p class="mulish-normal text-xxs color-5F5F5F">Your referral code</p>
                    <div class="referal">
                        <input type="text" id="referalcode" name="referalcode" placeholder="Referral code" class="w-100">
                    </div> -->
              <div class="referal">
                <p class="text-label text-xxs mulish-normal color-5F5F5F" for="referalcode">
                  {{'Your referral code' | translate}}</p>
                <input type="text" class="w-100" [(ngModel)]="strReferalCode" formControlName="referalcode" [ngClass]="{
                            'has-danger': referalfcontrol.referalcode.invalid && (referalfcontrol.referalcode.touched || submitted),
                            'has-success': referalfcontrol.referalcode.valid}" id="referalcode"
                  placeholder="{{'Referral code' | translate}}" required>
                <span *ngIf="referalfcontrol.referalcode.touched && referalsubmitted">
                  <small *ngIf="referalfcontrol.referalcode.invalid && referalfcontrol.referalcode.value == ''"
                    id="emailHelp" class="form-text text-danger">{{ errMessage | translate }}</small>
                  <small
                    *ngIf="referalfcontrol.referalcode.hasError('incorrect') && referalfcontrol.referalcode.value != ''"
                    id="emailHelp" class="form-text text-danger">{{ 'Invalid referral code' | translate }}</small>
                </span>

              </div>

            </form>
          </div>
        </div>
        <div class="col-12 px-0 mt-5">
          <div class="bg-danger d-flex text-13 text-white badge-custom align-items-center cursor-pointer mulish-bold"
            (click)="validateReferalCode()">
            <span> {{'Validate referral code' | translate | uppercase}} </span>
            <mat-icon class="ml-3">arrow_right_alt</mat-icon>
          </div>

        </div>
        <div class="col-12 px-0 mt-4 text-center">
          <p class="mulish-normal text-14 color-5F5F5F">{{'Already have an account?' | translate}}
            <a (click)="gotoLogin()" class="login-link font-red ml-1"><b> {{'Login Here' | translate}}
              </b></a> </p>
        </div>
        <div class="col-12 px-0 text-center">
          <p class="mulish-normal text-14 color-5F5F5F">
            <a (click)="gotoVideos()" class="login-link font-red ml-1"><b> {{'Click here' | translate}}
              </b></a>
            {{'to go to the videos section if you do not have a referral code.' | translate}}
          </p>
        </div>
      </div>

    </div>
  </div>
  <!-- validate referal code  -->


  <!-- complete profile  -->
  <div *ngIf="isReferalCodeVerified && !isprofileCompleted" class="w-100">
    <div class="col-12 px-0 complete-profile border-btm">
      <div class="pointer-cursor position-absolute right-align z-999 top-0 marginright-48">
        <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
      </div>
      <p class="mulish-800 text-16 pl-4">{{'Complete profile' | translate}}</p>

    </div>
    <div class="col-12 px-0 complte-profile-body modal-body-scroll">
      <div class="row mx-0">
        <div class="col-12 px-0 text-center">
          <div class="d-flex text-center justify-content-center">
            <img src="assets/images/referal-success.svg" alt="" width="28" height="28">
            <p class="pl-3 mulish-800 text-16 text-success">{{'Referral code verified' | translate}}</p>
          </div>

        </div>
        <div class="col-12 px-0 text-center mt-4">
          <p class="mulish-normal text-14">{{'We recognised you as a student from' | translate}}
            <span><b> {{referalVerifiedDetails['name']}}.</b>
            </span> {{'Kindly provide us your name and create a password to secure your account' | translate}}.</p>
        </div>
        <div class="col-12 px-0 complete-profile-form my-4">
          <form [formGroup]="completeProfileForm" (keyup.enter)="continueCompleteProfile()">
            <div class="">
              <p class="text-label text-xxs mulish-normal color-5F5F5F" for="name">{{'Your name' | translate}}*</p>
              <input type="text" class="w-100" [(ngModel)]="strUsername" formControlName="name" [ngClass]="{
                            'has-danger': fcontrol.name.invalid && (fcontrol.name.touched || submitted),
                            'has-success': fcontrol.name.valid}" maxlength="30" id="name"
                placeholder="{{'Enter your name' | translate}}" required>
              <span *ngIf="fcontrol.name.touched || submitted">
                <small *ngIf="fcontrol.name.invalid && fcontrol.name.value == ''" id="emailHelp"
                  class="form-text text-danger">{{ errMessage | translate }}</small>
              </span>

            </div>
            <div class="mt-4">
              <p class="text-label text-xxs mulish-normal color-5F5F5F" for="email">{{'Your email id' | translate}}</p>
              <input type="email" class="w-100" [(ngModel)]="strUserEmail" formControlName="email" [ngClass]="{
                            'has-danger': fcontrol.email.errors?.pattern && (fcontrol.email.touched || submitted),
                            'has-success': fcontrol.email.valid && (fcontrol.email.touched || submitted)}" id="email"
                placeholder="{{'Enter your email id' | translate}}">
              <span *ngIf="fcontrol.email.touched || submitted">
                <small *ngIf="fcontrol.email.errors?.pattern" id="emailHelp"
                  class="form-text text-danger">{{ mailError | translate }}</small>
                <!-- <small *ngIf="fcontrol.email.invalid && fcontrol.email.value == ''" id="emailHelp"
                  class="form-text text-danger">{{ errMessage | translate }}</small> -->
              </span>

            </div>
            <div class="mt-4">
              <p class="text-label text-xxs mulish-normal color-5F5F5F" for="password">
                {{'Create new password' | translate}}*</p>
              <input type="password" class="w-100" [(ngModel)]="strUserPassword" formControlName="password" [ngClass]="{
                            'has-danger': fcontrol.password.invalid && (fcontrol.password.touched || submitted),
                            'has-success': fcontrol.password.valid}" id="password" maxlength="10"
                placeholder="{{'Enter your password' | translate}}" required>
              <span *ngIf="fcontrol.password.touched || submitted">
                <small *ngIf="fcontrol.password.invalid && fcontrol.password.value == ''" id="emailHelp"
                  class="form-text text-danger">{{ errMessage | translate }}</small>
              </span>

            </div>
            <div class="mt-4">
              <p class="text-label text-xxs mulish-normal color-5F5F5F" for="confirmpass">
                {{'Re-enter your password' | translate}}*</p>
              <input type="password" class="w-100" [(ngModel)]="strUserConfirmPassword" formControlName="confirmpass"
                [ngClass]="{
                            'has-danger': fcontrol.confirmpass.invalid && (fcontrol.confirmpass.touched || submitted),
                            'has-success': fcontrol.confirmpass.valid}" id="confirmpass" maxlength="10"
                placeholder="{{'Re-enter your password' | translate}}" required>
              <span *ngIf="fcontrol.confirmpass.touched || submitted">
                <small *ngIf="fcontrol.confirmpass.invalid && fcontrol.confirmpass.value == ''" id="emailHelp"
                  class="form-text text-danger">{{ errMessage | translate }}</small>
                <small
                  *ngIf="fcontrol.confirmpass.value != fcontrol.password.value  && fcontrol.confirmpass.value != '' "
                  id="emailHelp" class="form-text text-danger">{{ 'Password should match' | translate }}</small>
              </span>

            </div>
            <div class="margin-top-32">
              <div
                class="bg-danger d-flex text-13 text-white  continue-custom align-items-center justify-content-center cursor-pointer mulish-bold"
                (click)="continueCompleteProfile()">
                <span> {{'Continue' | translate | uppercase}} </span>
                <mat-icon class="ml-3">arrow_right_alt</mat-icon>
              </div>

            </div>

          </form>


        </div>

      </div>

    </div>

  </div>

  <!-- complete profile  -->

  <!-- profile created  -->
  <div *ngIf="isReferalCodeVerified && isprofileCompleted" class="w-100">
    <div class="col-12 px-0 complete-profile border-btm">
      <div class="pointer-cursor position-absolute right-align z-999 top-0 marginright-48">
        <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
      </div>
      <p class="mulish-800 text-16 pl-4">{{'Complete profile' | translate}}</p>

    </div>
    <div class="col-12 px-0 complte-profile-body modal-body-scroll">
      <div class="row mx-0">
        <div class="col-12 px-0 text-center">
          <div class="d-flex text-center justify-content-center">
            <img src="assets/images/referal-success.svg" alt="" width="28" height="28">
            <p class="pl-3 mulish-800 text-16 text-success">{{'Your profile is created' | translate}}</p>
          </div>

        </div>
        <div class="col-12 px-0 mt-4 text-center">
          <p class="mulish-normal text-14">
            {{'Kindly note down your username and password for future sign up' | translate}}</p>
        </div>
        <div class="col-12 px-0 profile-credential mt-5">
          <div>
            <p class="mulish-normal text-xxs color-5F5F5F">{{'Username' | translate}}:</p>
            <p class="mulish-bold text-28">{{profileDetails['username']}}</p>
          </div>
          <div class="mt-5">
            <p class="mulish-normal text-xxs color-5F5F5F">{{'Password' | translate}}:</p>
            <p class="mulish-bold text-28">{{strUserPassword}}</p>
          </div>

        </div>
        <div class="col-12 px-0 mt-4">
          <div
            class="bg-danger d-flex text-13 text-white  continue-custom align-items-center justify-content-center cursor-pointer mulish-bold"
            (click)="profileCreated()">
            <span> {{'Continue' | translate | uppercase}} </span>
            <mat-icon class="ml-3">arrow_right_alt</mat-icon>
          </div>
        </div>
      </div>
    </div>


  </div>

  <!-- profile created  -->

</div>
